(function () {
    'use strict';
    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsNexusController', ObservationDefinitionsNexusController);
    
    ObservationDefinitionsNexusController.$inject = ['ObservationDefinitions', 'SoopkitchenUtils', '$uibModalInstance', '$state'];
    
    function ObservationDefinitionsNexusController(ObservationDefinitions, SoopkitchenUtils, $uibModalInstance, $state) {
        var vm = this;

        /**** Properties ****/
        vm.versions = null;
        vm.checked = {};
        vm.descriptions = {};

        /**** Methods ****/
        vm.clear = clear;
        vm.isValid = isValid;
        vm.importObsDef = importObsDef;


        ObservationDefinitions.loadNexusVersions(successLoadNexusVersions, failureLoadNexusVersions);
        
        function successLoadNexusVersions(response) {
            vm.versions = response.data;
        }
        
        function failureLoadNexusVersions(response) {
            clear();
            SoopkitchenUtils.prettyError(response);
        }
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValid() {
            for (var version in vm.checked) {
                if (vm.checked[version]) {
                    return true;
                }
            }
            return false;
        }

        function extractVersions() {
            var versionsToImport = {};
            for (var version in vm.checked) {
                if (vm.checked[version]) {
                    if (vm.descriptions.hasOwnProperty(version)) {
                        versionsToImport[version] = vm.descriptions[version];
                    } else {
                        versionsToImport[version] = '';
                    }
                }
            }
            return versionsToImport;
        }

        function successImportFromNexus(response) {
            SoopkitchenUtils.processResponse(
                response,
                "Observation Definitions Imported",
                "New Observation Definitions have been creatd in SoopKitchen",
                function () {
                    $state.go('observation-definitions');
                    $uibModalInstance.dismiss('cancel');
                }
            );
        }
        
        function failureImportFromNexus(response) {
            SoopkitchenUtils.prettyError(response);
        }
        
        function importObsDef() {
            var versionsToImport = extractVersions();
            ObservationDefinitions.importVersionsFromNexus(versionsToImport, successImportFromNexus, failureImportFromNexus);
        }
    }
})();
